import { render, staticRenderFns } from "./CardsView.vue?vue&type=template&id=140dfa67&scoped=true"
import script from "./CardsView.vue?vue&type=script&lang=js"
export * from "./CardsView.vue?vue&type=script&lang=js"
import style0 from "./CardsView.vue?vue&type=style&index=0&id=140dfa67&prod&lang=sass&scoped=true"
import style1 from "./CardsView.vue?vue&type=style&index=1&id=140dfa67&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140dfa67",
  null
  
)

export default component.exports